export default __webpack_public_path__ + "static/media/Gouhar-Mahal.197c9ed4.jpg";